import { recipe } from "@vanilla-extract/recipes";
import { keyframes } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

/**
 * Keyframes for the infinite scale animation
 */
const scaleAnimation = keyframes({
  "0%": {
    transform: "scale(1)",
    opacity: 0.5,
  },
  "50%": {
    transform: "scale(1.5)",
    opacity: 1,
  },
  "100%": {
    transform: "scale(1)",
    opacity: 0.5,
  },
});

/**
 * Base style for the agent blob
 */
export const agentBlobStyle = recipe({
  base: {
    display: "inline-block",
    borderRadius: "50%",
    background: "currentColor",
    animation: `${scaleAnimation} 2s ease-in-out infinite`,
    transformOrigin: "center center",
    width: rem(6),
    height: rem(6),
    marginTop: rem(6),
    marginLeft: rem(3),
  },
  variants: {
    speed: {
      slow: {
        animationDuration: ".5s",
      },
      normal: {
        animationDuration: "1s",
      },
      fast: {
        animationDuration: "2s",
      },
    },
    paused: {
      true: {
        animationPlayState: "paused",
      },
      false: {
        animationPlayState: "running",
      },
    },
  },
  defaultVariants: {
    speed: "normal",
    paused: false,
  },
});
